import { SEARCH } from "../constants";

export const searchCrimesByLocation = data => ({
  type: SEARCH.crimes_by_location,
  data
});

export const searchAvailability = () => ({
  type: SEARCH.availability
});

export const toggleAdvanced = () => ({
  type: SEARCH.toggle_advanced
});

export const changeDate = date => ({
  type: SEARCH.change_date,
  date
});

export const noAddress = date => ({
  type: SEARCH.no_address
});

export const showSearch = () => ({
  type: SEARCH.show_search
});

export const selectIncidents = selectedIncidents => ({
  type: SEARCH.select_incidents,
  selectedIncidents
});



// WEBPACK FOOTER //
// ./src/actions/search.js